import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

const Play = (props: IconSvgProps) => {
  return (
    <BaseLibraryIconSvg {...props} viewBox='0 0 80 80'>
      <circle cx='40' cy='40' r='39.5' stroke='currentColor' />
      <path
        d='M29.0698 21.0709L61.8555 39.9997L29.0698 58.9286L29.0698 21.0709Z'
        stroke='currentColor'
      />
    </BaseLibraryIconSvg>
  );
};

export default Play;
